import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router'
import MainContent from '../../components/wrappers/MainContent'
import './infoViews.pcss'

export default class SourceTermsView extends Component {
  render() {
    return (
      <MainContent>
        <article className='info-page'>
          <Helmet title='Ohjeet lähdemedioille' />

          <h1 style={ { textTransform: 'uppercase' } }>Ampparit-palvelun käyttöehdot lähdemedioille</h1>

          <h2>1. Yleistä</h2>
          <p>
            1.1 Alma Media Finland Oy (”Alma”) ylläpitää Ampparit-palvelua, jonka kautta Ampparit-
            palvelun käyttäjät ohjautuvat linkkien kautta eri uutislähteiden omille sivustoille, jossa he
            voivat lukea uutisia eri lähdesivustoilta. Ampparit-palvelu on toteutettu sekä nettisivustona
            että sovelluksena.
          </p>
          <p>
            1.2 Näitä käyttöehtoja sovelletaan Ampparit-palvelun ja lähdemedioiden (”Lähdemedia”) välillä
            ja jolleivat osapuolet ole muutoin kirjallisesti sopineet, nämä ehdot ovat ensisijaisia suhteessa
            aiemmin sovittuihin yhteistyön ehtoihin.
          </p>


          <h2>2. Käyttöoikeudet</h2>
          <p>
            2.1 Lähdemedia hyväksyy, että Alma lukee lähdesivuston RSS-syötteen sisältöä ja ohjaa
            liikennettä Ampparit-palvelun kautta lähdesivustolle lukemaan alkuperäisen sisällön.
            Lähdemedia hyväksyy, että Alma näyttää Ampparit-palvelussa Lähdesivuston otsikot.
            Lähdemedia voi lisätä tai poistaa lähdesivustoja ottamalla yhteyttä Ampparit-palvelun
            ylläpitoon.
          </p>
          <p>
            2.2 Lähdemedia vakuuttaa, että sillä on oikeus luovuttaa sisältöjen käyttöoikeus Almalle edellä
            kuvattuun tarkoitukseen ja että sisältöjen käyttö Ampparit-palvelussa ei loukkaa kenenkään
            tekijänoikeuksia, niiden lähioikeuksia tai muita oikeuksia. Lähdemedia myöntää Almalle
            oikeuden käyttää logojaan, tavaramerkkejään ja muita tunnuksia Ampparit-palvelussa. Mikäli
            ja siltä osin kuin tekijänoikeuslain 50 §:ssä tarkoitettu lehtikustantajan lähioikeus soveltuu
            yhteistyöhön, Lähdemedian Almalle luovuttamat oikeudet käsittävät vastikkeetta myös
            tekijänoikeuslain 50 §:ssä tarkoitetun lehtikustantajan lähioikeuden edellyttämän
            suostumuksen.
          </p>
          <p>
            2.3 Almalle myönnetyt oikeudet säilyvät voimassa myös yhteistyön päättymisen jälkeen
            sellaisten sisältöjen ja tunnusten osalta, joita Alma on käyttänyt Ampparit-palvelussa
            yhteistyön aikana.
          </p>
          <p>
            2.4 Kaikki oikeudet Ampparit-palveluun ja muihin Alman immateriaalioikeuksiin säilyvät
            Almalla eikä Lähdemedialle anneta niihin näillä ehdoilla mitään oikeuksia. Mikäli Lähdemedia
            haluaa näyttää lähdesivustolla Ampparit-palvelun logoa, sovitaan siitä osapuolten välillä
            erikseen.
          </p>


          <h2>3. Vastuut sisällöistä</h2>
          <p>
            3.1 Lähdemedia vastaa siitä, että lähdesivustolla julkaistu sisältö ei ole laitonta, hyvän tavan
            vastaista tai muuten julkaistavaksi kelpaamatonta.
          </p>
          <p>
            3.2 Lähdemedia sitoutuu noudattamaan Alman kulloinkin voimassa olevia Ampparit-sivuston
            uutislähteille annettuja kohtuullisia ohjeita ja vaatimuksia. Kulloinkin voimassa olevat
            ohjeet ja vaatimukset löytyvät seuraavien linkkien takaa:
            { ' ' } <Link to='/tietoa/lahteille' target='_blank'>https://www.ampparit.com/tietoa/lahteille</Link> ja
            { ' ' } <Link to='/tietoa/mukaan' target='_blank'>https://www.ampparit.com/tietoa/mukaan</Link>.
          </p>


          <h2>4. Palvelun käytön seuranta</h2>
          <p>
            4.1 Almalla on oikeus seurata Ampparit-palvelun käyttöä ja palvelun kautta tapahtuvaa
            liikennettä lähdesivustolle omien käytäntöjensä mukaisesti. Alma käyttää tietoa muun muassa
            palvelun kehittämiseksi ja personoimiseksi käyttäjille. Alma voi tehdä linkittämiensä
            lähdesivustojen otsikoista tilastollista analysointia siten, ettei julkaistusta tilastosta voi
            tunnistaa yksittäistä lähdesivustoa.
          </p>


          <h2>5. Kustannukset</h2>
          <p>
            5.1 Kumpikin osapuoli vastaa itse omista kustannuksistaan, jotka aiheutuvat näiden ehtojen
            mukaisten velvoitteiden täyttämisestä.
          </p>


          <h2>6. Salassapito</h2>
          <p>
            6.1 Osapuolet sitoutuvat pitämään salassa kaikki toistensa luottamukselliseksi merkityt tai
            sellaiseksi ymmärrettävät tiedot, jotka ne saavat tietoonsa yhteistyön puitteissa, sekä olemaan
            käyttämättä näitä tietoja muuhun kuin yhteistyön toteuttamiseen. Salassapitovelvollisuus
            säilyy voimassa myös yhteistyön päättymisen jälkeen.
          </p>


          <h2>7. Yhteistyön voimassaolo ja päättäminen</h2>
          <p>
            7.1 Yhteistyö jatkuu toistaiseksi voimassa olevana. Kummallakin osapuolella on oikeus
            irtisanoa yhteistyö ilmoittamalla siitä kirjallisesti toiselle osapuolelle kolme (3) kuukautta
            etukäteen.
          </p>
          <p>
            7.2 Kummallakin osapuolella on oikeus purkaa yhteistyö, jos toinen osapuoli rikkoo
            olennaisesti yhteistyön ehtoja eikä korjaa rikkomustaan 14 päivän kuluessa kirjallisesta
            ilmoituksesta.
          </p>

          <h2>8. Vahingonkorvausvastuu</h2>
          <p>
            8.1 Kumpikaan osapuoli ei vastaa toiselle osapuolelle aiheutuneesta välillisestä tai epäsuorasta
            vahingosta. Vastuunrajoituksia ei sovelleta, jos vahinko on aiheutettu tahallisesti, törkeällä
            huolimattomuudella tai rikkomalla salassapitovelvollisuutta, eikä lähdesivustolla julkaistuja
            sisältöjä koskeviin Lähdemedian vastuisiin.
          </p>


          <h2>9. Sovellettava laki ja riidanratkaisu</h2>
          <p>
            9.1 Yhteistyöhön sovelletaan Suomen lakia, pois lukien sen lainvalinnat.
          </p>
          <p>
            9.2 Yhteistyöstä mahdollisesti aiheutuvat erimielisyydet, joita osapuolet eivät kykene
            ratkaisemaan sovinnollisesti, ratkaistaan lopullisesti yksijäsenisessä välitysmenettelyssä
            Keskuskauppakamarin välitysmenettelysääntöjen mukaisesti. Välitysmenettely käydään
            Helsingissä ja sen kielenä on suomi.
          </p>


          <h2>10. Muut ehdot</h2>
          <p>
            10.1 Osapuolella ei ole oikeutta siirtää yhteistyöhön liittyviä oikeuksiaan ja velvollisuuksiaan
            kolmannelle osapuolelle ilman toisen osapuolen kirjallista hyväksyntää. Almalla on kuitenkin
            oikeus siirtää yhteistyötä koskeva sopimus konserniyhtiölleen tai liiketoimintajärjestelyjen
            yhteydessä ilmoittamalla siirrosta kirjallisesti Lähdemedialle.
          </p>
          <p>
            10.2 Almalla on oikeus muuttaa näitä ehtoja ilmoittamalla muutoksesta kohtuullisen ajan
            etukäteen Ampparit-palvelussa ja mahdollisuuksien mukaan sähköpostitse Lähdemedian
            ilmoittamalle yhteyshenkilölle. Lähdemedian vastuulla on pitää Alma ajan tasalla kulloisesta
            yhteyshenkilöstään.
          </p>
        </article>
      </MainContent>
    )
  }
}
